import api from "../../../../store/AuthHeader";

const getAllJobSubCategoriesByJobCategoryID = (queryStr: any, categoryId: any) => {
    return api.get("/JobSubCategory/GetAllJobSubCategoriesByJobCategoryID?" + queryStr +'&id='+ categoryId);
}

const getJobSubCategoryById = (id: number) => {
    return api.get(`/JobSubCategory/GetJobSubCategoryById?id=${id}`);
}

const addJobSubCategory = (payload: any) => {
    return api.post("/JobSubCategory", payload);
}

const updateJobSubCategory = (id: number, payload: any) => {
    return api.put(`/JobSubCategory/${id}`, payload);
}

const deleteJobSubCategoryById = (itemToDeleted: number) => {
    return api.delete(`/JobSubCategory/${itemToDeleted}`);
}

export default {
    getAllJobSubCategoriesByJobCategoryID,
    getJobSubCategoryById,
    addJobSubCategory,
    updateJobSubCategory,
    deleteJobSubCategoryById
}